module.exports = __webpack_public_path__ + "img/BD.c20f91fc.svg";